(() => {
window.L1NOFormCaptchaWatch = (form, submit, submitLabel) => {
const startedAt = Date.now();
let challengeWasVisible = false;
let challengeHiddenAt = 0;
const reset = () => {
form.removeAttribute('aria-busy');
delete form.dataset.l1noNativeReady;
if (submit) {
submit.disabled = false;
submit.textContent = submitLabel;
}
};
const timer = window.setInterval(() => {
if (!form.isConnected || form.querySelector('[data-form-status][data-state="success"]:not([hidden])')) {
window.clearInterval(timer);
return;
}
const challenge = [...document.querySelectorAll('iframe[src*="frame=challenge"]')].find((frame) => {
const style = getComputedStyle(frame);
const rect = frame.getBoundingClientRect();
return style.visibility !== 'hidden' && style.display !== 'none' && rect.width > 0 && rect.height > 0;
});
if (challenge) {
challengeWasVisible = true;
challengeHiddenAt = 0;
return;
}
if (form.elements.namedItem('h-captcha-response')?.value?.trim()) return;
if (challengeWasVisible) {
if (!challengeHiddenAt) challengeHiddenAt = Date.now();
if (Date.now() - challengeHiddenAt < 1500) return;
} else if (Date.now() - startedAt < 10000) {
return;
}
window.clearInterval(timer);
reset();
}, 500);
};
})();
